import { render, staticRenderFns } from "./VisualDropdown.vue?vue&type=template&id=668199d8&scoped=true"
import script from "./VisualDropdown.js?vue&type=script&lang=js&external"
export * from "./VisualDropdown.js?vue&type=script&lang=js&external"
import style0 from "./VisualDropdown.scss?vue&type=style&index=0&id=668199d8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668199d8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotLink: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Link/Link.vue').default})
